module.exports=function(href){var l=document.createElement("a");return l.href=href,l};